
<section class="rtl pt-32 py-16 main-bg">
    <div class="container mx-auto px-4">
        <div class="flex justify-center">
            <div class="w-full lg:w-6/12 xl:w-8/12 p-4">
                <div class="bg-white rounded p-4 mb-6 shadow-lg">
                    <div class="flex justify-center">
                        <h5 class="font-semibold text-xl my-4"> اطلاعات ویزیت و مشاوره </h5>
                    </div>
                    <hr>
                    <div class="bg-primary-light text-primary my-4 p-4">
                        <div class="flex justify-around my-2 p-2">
                            <p> نام پزشک: </p>
                            <p> {{visit.doctorName}} </p>
                        </div>
                        <div class="flex justify-around my-2 p-2">
                            <p> نوع ویزیت: </p>
                            <p> {{visit.visitType==1?'متنی':visit.visitType==2?'تلفنی':visit.visitType==3?'تصویری':visit.visitType==4?'حضوری':null}} </p>
                        </div>
                        <div class="flex justify-around my-2 p-2">
                            <p> تاریخ: </p>
                            <p> {{ visit.visitDate|shamsiDate }} </p>
                        </div>
                        <div class="flex justify-around my-2 p-2">
                            <p> ساعت: </p>
                            <p> {{convertUTCMinutesToLocal(visit.startVisit)}} </p>
                        </div>
                    </div>
                    <hr>
                    <div class="my-4 text-center">
                        <button class="bg-primary text-white w-3/12 rounded py-3 mb-1" type="button"
                            (click)="openVisitLink()" [disabled]="isActiveVisitLink()"> ورود </button>
                    </div>
                    <div class="my-6">
                        <p *ngIf="!isTodayVisit()"> تاریخ ویزیت:
                            {{ visit.visitDate|shamsiDate }}
                        </p>
                        <p *ngIf="isTodayVisit()"> زمان باقی مانده:
                            <span class="text-primary"> {{getRemainingTime(visit.startVisit)}}  </span>    
                            دقیقه
                        </p>
                    </div>

                </div>

            </div>

        </div>
    </div>
</section>
